<template>
  <vjs-modal v-bind="$options.propsData" icon="la la-share-alt-square" :title="title ? title : `Share: ${entity.name}`">
    <template slot="body-content">
      <ul class="social-share-modal-items clean-list">
        <li>
          <button type="button" class="btn btn-ss" @click="() => copyPlayerLinkToClipboard(entity)">
            <i class="la la-link" />Copy Player Link
          </button>
        </li>
        <li>
          <button type="button" class="btn btn-ss" @click="() => copyEmbedToClipboard(entity)">
            <i class="la la-code" />Copy Embed Code
          </button>
        </li>
        <li v-if="entity.feed_xml_file_url">
          <button type="button"
                  class="btn btn-ss"
                  @click="() => copyRSSToClipboard(entity)">
            <i class="la la-rss" />Copy RSS Link
          </button>
        </li>

        <li v-if="entity.published">
          <button type="button"
                  class="btn btn-ss"
                  @click="() => copyDirectFileLinkClipboard(entity)">
            <i class="la la-link" />Copy Direct File Link
          </button>
        </li>
      </ul>
      <ul class="social-share-modal-items clean-list">
        <li>
          <button type="button" class="btn btn-ss" @click="() => shareOnFacebook(entity)">
            <i class="socicon-facebook" />Facebook
          </button>
        </li>
        <li>
          <button type="button" class="btn btn-ss" @click="() => shareOnTwitter(entity)">
            <i class="socicon-twitter" />Twitter
          </button>
        </li>
        <li>
          <button type="button" class="btn btn-ss" @click="() => shareOnWhatsapp(entity)">
            <i class="socicon-whatsapp" />Whatsapp
          </button>
        </li>
      </ul>
    </template>
    <template slot="body-controls">
      <b-button variant="ss" @click="complete">
        Close
      </b-button>
    </template>
  </vjs-modal>
</template>

<script>
import VjsModal from 'VueModals/VjsModal';
import VjsModalMixin from 'VueModals/VjsModalMixin';
import SocialShareMixin from 'VueMixins/SocialShareMixin';

export default {
  name: `social-share-modal`,
  components: {
    VjsModal,
  },
  mixins: [VjsModalMixin, SocialShareMixin],
  props: {
    title: {
      type: String,
      default: null,
      required: false,
    },
    entity: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.social-share-modal-items {
	display: flex;
	flex-wrap: wrap;
	width: 100%;
	justify-content: center;
	li {
		display: flex;
		flex-direction: column;
		align-items: center;
		margin: 1em 0.3em;
    width: 200px;
		.btn {
			width: 100%;
			height: 100%;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: space-around;
			i {
				font-size: 2em;
				line-height: 1em;
				padding: 0;
				margin: 0;
			}
		}
	}
}
</style>
